import { showGlobalNotification } from "./actions/globalNotificationActions";
import format from "string-format";
// todo: does it need toastr.options.rtl = true config ?
/* eslint-disable no-console, no-constant-condition */

export const signalrStarter = (store, hubURL, lang, callback = () => {}) => {
  try {
    do {
      if (!window.jQuery && !$.hubConnection) {
        console.warn("jQuery is not loaded, aborting signalR.");
        break;
      }
      const connection = $.hubConnection(hubURL);
      if (!connection) {
        console.warn("signalR connection is not established, aborting.");
        break;
      }
      const hub = connection.createHubProxy("BookingEngineHub");
      window._hub = hub;

      // Hub client functions
      window._hub.on("notifyViewersNumber", function(viewersNumber) {
        const { titles } = store.getState();
        store.dispatch(
          showGlobalNotification(
            format(titles.SignalrViewerNumbersNotification, viewersNumber)
          )
        );
      });

      // Start the connection.
      connection.start().done(() => {
        callback();
      });
      connection.error(err => {
        console.log("signalR connection start failed", err);
        callback();
      });
    } while (false);
  } catch (error) {
    console.log("signalR not supported", error);
    callback();
  }
};

export const generateGroupNameCode = hotelId => {
  return `H${hotelId}`;
};



// WEBPACK FOOTER //
// ./src/signalrStarter.js